import { FC, PropsWithChildren } from 'react';
import { ConditionalProps } from './types';

export const Conditional: FC<PropsWithChildren<ConditionalProps>> = ({
  children,
  fallback = null,
  test,
}) => {
  return <>{test ? children : fallback}</>;
};
